import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ActivityEntityName, ContractorWorkOrder, DocumentThemeAny, DocumentThemeScopeRequest, Entity } from '@jms/model';
import { onDownloadError, FilenameExtractService } from '@jms/utils/util.download';
import { ToastService } from '@workbuddy/ui/services';
import saveAs from 'file-saver';
import Enumerable from 'linq';
import { from, map, catchError, of, Observable, tap, EMPTY } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContractorReportService {

    private readonly api = 'https://__tenant__/api/portal/contractor';
    private readonly documentThemeApi = 'https://__tenant__/api/picker/document-themes';
    private readonly downloadApi = 'https://__tenant__/api/config/merge/download';
    private readonly http = inject(HttpClient);
    private readonly toastService = inject(ToastService);

    constructor() { }

    public downloadLegacyWorkOrderReport(jobId: string, workOrderId: string): Observable<any> {

        const request = {
            jobId,
            workOrderId
        };

        const url = `${this.api}/operations/workorder/download/workordersummary`;

        return this.http.post(url, request, { responseType: 'blob' })
            .pipe(
                map(res => res),
                catchError(err => {
                    return of({});
                })
            );

    }

    public getThemeEntities(workOrder: ContractorWorkOrder): Observable<DocumentThemeAny[]> {

        const url = `${this.documentThemeApi}/${ActivityEntityName.WorkOrder}`;
        const request = {
            companyIds: [],
            jobTypes: [],
            workCategories: [],
            entities: [
                ActivityEntityName.WorkOrder,
                ActivityEntityName.WorkOrderDispatch
            ]
        } as DocumentThemeScopeRequest;
        return this.http.post<DocumentThemeAny[]>(url, request)
            .pipe(
                map(x => {
                    return Enumerable
                        .from(x)
                        .orderBy(x => x.name)
                        .toArray();
                })
            );
    }

    public getDefaultTheme(entity: ActivityEntityName): Observable<Entity> {
        return this.http.get<Entity>(`${this.documentThemeApi}/${entity}/default`);
    }

    public downloadTheme(entityName: ActivityEntityName, entity: Entity, themeId: string, stringFileName: string): void {
        let fullUrl = `${this.downloadApi}/${entityName}/${entity._id}?filename=${stringFileName ?? 'DownloadFile'}`;
        if (themeId) {
            fullUrl += `&themeId=${themeId}`;
        }

        this.http.get(fullUrl, { observe: 'response', responseType: 'blob' })
            .pipe(
                tap(data => {
                    const filename = FilenameExtractService.extractFilenameFromResponse(data, `${stringFileName}.pdf`);
                    saveAs(data.body as Blob, filename);
                }),
                catchError(onDownloadError(this.toastService, () => EMPTY))
            )
            .subscribe();
    }
}